// Centralized Tailwind color tokens for the Associate Fee, Journal Entry
// and Check column tables. All color values come from the shared
// `palette` namespace in `tailwind.config.js` (common color names ×
// {badge, soft, text}), so the three tabs stay visually consistent and
// re-theming a column means swapping a color name here.

/** Indigo link used for clinic codes and practitioner names. */
export const LINK_CLASSES =
  "text-left font-semibold text-palette-indigo-heading hover:text-palette-indigo-primary hover:underline focus:outline-none focus:ring-2 focus:ring-palette-indigo-hover rounded";

/** Practitioner-type pill backgrounds (TYPE column). */
export const TYPE_PILL_COLORS = {
  DDS: "bg-palette-indigo-soft text-palette-indigo-text",
  HYG: "bg-palette-purple-soft text-palette-purple-text",
  default: "bg-palette-gray-soft text-palette-gray-text",
};

/** DDS DRAW column (green). */
export const DDS_DRAW_COLORS = {
  header: "bg-palette-green-badge text-white font-bold",
  cell: "bg-palette-green-soft",
};

/** PRODUCTION / COLLECTION columns (sky blue). */
export const PROFIT_COLORS = {
  header: "!bg-palette-sky-badge !text-white font-bold",
  cell: "bg-palette-sky-soft",
  empty: "text-palette-sky-text/70 text-xs",
  text: "text-palette-sky-text",
};

/** OTHER PROFIT column (sky blue — same family as PROFIT). */
export const OTHER_PROFIT_COLORS = {
  header: "!bg-palette-sky-badge !text-white font-bold",
  cell: "bg-palette-sky-soft",
  text: "text-palette-sky-text",
};

/** TOTAL FEE column (rose). */
export const TOTAL_FEE_COLORS = {
  header: "!bg-palette-rose-badge !text-white font-bold",
  cell: "bg-palette-rose-soft text-center",
  text: "text-palette-rose-text",
};

/**
 * "Deduction" columns (slate header, violet cell): lab_cost,
 * material_cost, invisalign_cost, anesthesia_fee, anesthesiologist_fee,
 * facility_fee, botox, production_adjustment, collection_adjustment,
 * other_deduction, insurance.
 */
export const DEDUCTION_COLORS = {
  header: "!bg-palette-slate-badge !text-white font-bold",
  cell: "bg-palette-violet-soft",
  text: "text-palette-slate-text",
};

/** ASSOCIATE FEE % column (amber). */
export const FEE_PERCENT_COLORS = {
  header: "!bg-palette-amber-badge !text-white font-bold",
  cell: "bg-palette-amber-soft",
};

/** CHECK column header (emerald) — Check tab only. */
export const CHECK_HEADER_COLOR = "!bg-palette-emerald-badge !text-white font-bold";
